import React from 'react';
import { useLanguage } from './LanguageContext';
import './PartnerMarquee.css';

const BADGES = [
  {
    logo: '/badges/dedge-bw.png',
    alt: 'Dedge Security',
    label: { en: 'Cybersecurity Partner', es: 'Partner de Ciberseguridad' },
    screenBlend: true,  // Uses screen blend in dark, invert in light
  },
  {
    logo: '/badges/hedera-full.svg',
    alt: 'Hedera',
    label: { en: 'Official Partner · Builders Program', es: 'Partner Oficial · Programa Builders' },
    themeAware: true,  // Uses CSS filter based on theme
  },
  {
    logo: '/badges/enisa.png',
    alt: 'ENISA · Gobierno de España',
    label: { en: 'Certified Innovative Tech Startup', es: 'Startup Tecnológica Innovadora Certificada' },
    // No special handling - show as-is
  },
];

const PartnerMarquee = () => {
  const { language } = useLanguage();
  const isEN = language === 'en';

  // Triplicate for seamless loop
  const items = [...BADGES, ...BADGES, ...BADGES];

  return (
    <div className="partner-marquee-wrapper">
      <div className="partner-marquee-track-container">
        {/* Fade edges */}
        <div className="partner-marquee-fade partner-marquee-fade--left" />
        <div className="partner-marquee-fade partner-marquee-fade--right" />

        <div className="partner-marquee-track partner-marquee-track--badges">
          {items.map((badge, i) => (
            <div key={i} className="pm-badge-item">
              <img
                src={badge.logo}
                alt={badge.alt}
                className={`pm-badge-logo${badge.themeAware ? ' pm-badge-logo--theme' : ''}${badge.screenBlend ? ' pm-badge-logo--screen-blend' : ''}`}
                draggable={false}
              />
              <span className="pm-badge-label">
                {isEN ? badge.label.en : badge.label.es}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnerMarquee;
